module.exports = __webpack_public_path__ + "node_modules/@taxfyle/web-commons/lib/assets/img/taxfyle-icon-256px.png";